export default {
  dev: {
    userPoolId: 'us-east-1_Nofg1UvIB',
    userPoolWebClientId: '5e1aifqo4pf87uabaf5l9at41h',
    identityPoolId: 'us-east-1:279354a4-efc0-42d7-b5cf-54bf031a9adc',
    region: 'us-east-1',
  },

  qa: {
    userPoolId: 'us-east-1_zty39feft',
    // userPoolWebClientId: "4bdbm39222i0u6o8npsvipujh2",
    userPoolWebClientId: '103fl398ei65i5g3pul0t327mj',
    identityPoolId: 'us-east-1:e59e1ae4-637e-4a21-9289-6612b6382667',
    region: 'us-east-1',
  },

  stage: {
    userPoolId: 'us-east-1_OEIxy801j',
    // userPoolWebClientId: "7q4b7s2pk8k5uhumnq1tdfsvfq",
    userPoolWebClientId: '3he7teu6m7c2v0roti0mehcaga',
    identityPoolId: 'us-east-1:d36e6685-f49d-4437-9e50-06d847b3bf8c',
    region: 'us-east-1',
  },
  prod: {
    userPoolId: 'us-east-1_YONioZ8zx',
    userPoolWebClientId: '2vejcaa0vi6hlc0ofs27d9ajcm',
    identityPoolId: 'us-east-1:b34e6adf-bce0-43cc-a094-168cfae26b0f',
    region: 'us-east-1',
  },
  testes: {
    userPoolId: 'us-east-1_N4cXptYRf',
    userPoolWebClientId: '4qoimsr49ks9tssnmu0i2rtvci',
    identityPoolId: 'us-east-1:8aaa0a3b-c6f8-412a-8b6b-506d2ebfa536',
    region: 'us-east-1',
  },
};
